(function fixRandomisedFormIds($, Drupal) {
  // See https://www.drupal.org/project/drupal/issues/1852090#comment-13624394.
  Drupal.behaviors.rutherfordFixRandomisedFormIds = {
    attach(context) {
      // Update form element labels for elements that have had their ID
      // altered by _rutherford_prevent_duplicate_form_element_ids().
      const formElementWrapperClass = '.js-form-item';

      $(formElementWrapperClass, context)
        .find("[id$='--randomised']")
        .each(function fixRandomisedFormIds() {
          const inputId = $(this).attr('id');

          $(this)
            .closest(formElementWrapperClass)
            .find('label')
            .attr('for', inputId);
        });
    },
  };
})(jQuery, Drupal);
